/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/useQaShortcuts.ts
 * FILE_ID: JOBHUB-QA-SHORTCUT-HOOK-001
 * PURPOSE: Window shortcuts for the open QA workspace only.
 */
import { useEffect } from 'react'
import { isTextInputTarget } from '@quotech/ui'
import {
  loadQaShortcutOverrides,
  qaComboFromEvent,
  resolveQaAction,
} from '../../qa/qaShortcuts'

export function useQaShortcuts({
  onOpenTemplates,
  onInsertBlank,
}: {
  onOpenTemplates: () => void
  onInsertBlank: () => void
}) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (document.querySelector('[data-qa-shortcut-capture]')) return
      const root = document.querySelector('[data-qa-workspace]')
      if (!root || (root as HTMLElement).offsetParent === null) return
      if (isTextInputTarget(event.target)) return
      const combo = qaComboFromEvent(event)
      if (!combo) return
      const action = resolveQaAction(loadQaShortcutOverrides(), combo)
      if (action === 'structure.templates') {
        event.preventDefault()
        onOpenTemplates()
      } else if (action === 'structure.blank') {
        event.preventDefault()
        onInsertBlank()
      }
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [onOpenTemplates, onInsertBlank])
}
